import React, { useState } from "react";

import { FormButton } from "components";
import { Form, Formik } from "formik";

import { useRecoilValue, useSetRecoilState } from "recoil";
import { rowSelected, snackbarData, userCredentials } from "recoilState/GlobalState";

import styles from "styles/pages/ModalActions.module.scss";
import { handleResponse } from "services/Local-services";
import { SFLoteVoucherDel } from "services/services-mia/SFHotel";

export default function LoteDeleteModal({ updateList, closeModal, row }) {
    const setSelected = useSetRecoilState(rowSelected);
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);

    const [inRequest, setInRequest] = useState(false);

    const handleSubmit = async () => {
        setInRequest(true);

        const response = await SFLoteVoucherDel({
            SFLoteVoucherId: row.SFLoteVoucherId
        }, credentials);

        handleResponse(response, "El lote de vouchers ha sido eliminado exitosamente", {
            setSnackbarInfo,
            setIsOpen: closeModal,
            setSelected,
            updateList,
        });

        setInRequest(false);
    };

    return (
        <Formik
            initialValues={{ loteId: row.SFLoteVoucherId }}
            onSubmit={(_, { setSubmitting }) => {
                try {
                    handleSubmit();
                } catch (e) {
                    setSnackbarInfo({ message: e.errmsg, severity: "error", open: true });
                } finally {
                    setSubmitting(false);
                }
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column-sm"]}>
                    <h2 style={{ textAlign: "center" }}>
                        ¿Estás seguro que deseas eliminar el lote de{" "}
                        <strong>{row.merchantServicioUsuarioApellido}, {row.merchantServicioUsuarioNombre}</strong>?
                    </h2>
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Eliminar" }}
                        onCloseModal={closeModal}
                    />
                </div>
            </Form>
        </Formik>
    );
}
